import React from 'react';

class ErrorBoundary extends React.Component {
    state = {
        hasError: false
    };

    componentDidCatch(error, info) {
        this.setState({
            hasError: true
        }, () => {
            localStorage.clear();
        });
    }

    render() {
        const {hasError} = this.state;
        const {children} = this.props;

        return hasError ? null : children;
    }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/core/admin/ErrorBoundary.js